export enum SyncState {

    SYNC_OK = 'SYNC_OK',

    NOT_SYNCED = 'NOT_SYNCED',
    LOCAL_CHANGE = 'LOCAL_CHANGE'

}
